import React from 'react';
import { renderToString } from 'react-dom/server';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import { DeliveryPlan } from 'services/action';

import { Print } from 'ui/components';
import { formatDate, waFormat } from 'utilities/common';

import logoBlack from 'ui/assets/envio-black.png';

const PrintFulfillment = ({ match }) => {
  const Dispatch = useDispatch();
  const client = useSelector((state) => state?.Auth?.session?.client);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Fulfillment.Show']
  );
  const [data, setData] = React.useState(null);
  const [loaded, setLoaded] = React.useState(false);
  const [page, setPage] = React.useState(null);
  const [limit, setLimit] = React.useState(25);

  const $onLoad = async (id) => {
    const req = await Dispatch(DeliveryPlan.$show(id));
    if (req?.message === 'success') {
      setData(req?.data);
    }
  };

  React.useEffect(() => {
    setLoaded(false);


    $onLoad(match?.params?.id);
  }, []);

  React.useEffect(() => {
    if (data) {
      let limit = 25

      if (data?.items?.length > 20 && data?.items?.length <= 25) {
        limit = data?.items?.length - 1
      }

      let pages = _.chunk(data?.items, limit);
      setPage(pages)
      setLimit(limit);
      setPage(pages);
      setLoaded(true);
    }
  }, [data]);

  if (StateLoading || data === null || !loaded) return null;

  return (
    <div>
      <Print
        title={`Fulfillment - ${data?.code}`}
        size="A4"
        content={renderToString(
          <>
            {page?.map((p, key) => (
              <section
                className="sheet page-break"
                style={{ padding: '20px 60px' }}
                key={key}
              >
                {key === 0 && (
                  <>
                    <table className='header' cellSpacing={0} cellPadding={2}>
                      <tr>
                        <td style={{verticalAlign: 'middle'}}>
                          <img src={client?.avatar || logoBlack} alt="" height="50px" />
                        </td>
                        <td style={{verticalAlign: 'bottom', textAlign:'center'}}>
                          <p style={{fontSize:28, fontWeight: 800}}>Surat Jalan</p>
                        </td>
                      </tr>
                    </table>

                    <table className='body'
                      cellPadding={2}
                      verticalAlign="top"
                      style={{
                        marginTop: 10,
                        paddingTop: 10,
                        verticalAlign: 'top',
                        fontSize: 12,
                        borderTop: "1px solid #000"
                      }}
                    >
                      <tr>
                        <td style={{
                          paddingRight: 30,
                          width: '50%',
                          verticalAlign: 'top'
                        }}>
                          <pre style={{
                            margin:0,
                            padding: 0,
                            whiteSpace: 'pre-line'
                          }}>
                            SHIPPED TO: <br/><br/> {data?.recipient_name?.toUpperCase()} <br/> {data?.recipient_address?.toUpperCase()} <br/>
                            {data?.recipient_region?.district_name}, {data?.recipient_region?.regency_name}, {data?.recipient_region?.province_name}
                            {waFormat(data?.recipient_phone)}
                          </pre>
                        </td>
                        <td style={{
                          paddingLeft: 100,
                          textAlign: 'left',
                          verticalAlign: 'top'
                        }}>
                          <pre style={{
                            margin:0,
                            padding: 0,
                            whiteSpace: 'pre-wrap'
                          }}>
                            Fulfillment   : {data?.code} <br/>REF CODE      : {data?.ref_code} <br/>SHIPPING DATE : {formatDate(data?.shipping_date, 'DD/MM/YYYY') }
                          </pre>
                        </td>
                      </tr>
                    </table>
                  </>
                )}

                <table className='body'
                  style={{
                    marginTop: 10,
                    paddingLeft: 2,
                    paddingRight: 2,
                    fontSize: 12,
                    tableLayout: 'fixed'
                  }}
                >
                  <thead>
                    <th width="5%">NO</th>
                    <th width="50%">ITEM #</th>
                    <th width="10%">QTY</th>
                    <th width="20%">FRACTION</th>
                    <th width="5%">P</th>
                    <th width="5%">C</th>
                  </thead>
                  <tr>
                    <td colSpan={6}></td>
                  </tr>
                  {p?.map((item, i) => (
                    <tr key={`item-${key}-${i}`}>
                      <td className='center'>
                        <pre style={{
                          margin: 0,
                          padding: 0
                        }}>
                          {limit * key + (i + 1)}
                        </pre>
                      </td>
                      <td>
                        <pre style={{
                          margin: 0,
                          padding: 0,
                          wordWrap: 'break-word',
                          whiteSpace: 'normal'
                        }}>
                          {item?.item?.alias_name}
                          <br/>
                        </pre>
                        <span style={{fontSize: 10}}>{item?.item?.code}</span>
                      </td>
                      <td className='right'>
                        <pre style={{
                          margin: 0,
                          padding: 0
                        }}>
                          {item?.quantity_planned} {item?.item?.default_fraction}
                        </pre>
                      </td>
                      <td className='right'>
                        <pre style={{
                          margin: 0,
                          padding: 0
                        }}>
                          {item?.quantity_planned_fracted}
                        </pre>
                      </td>
                      <td className="right">[&nbsp;&nbsp;]</td>
                      <td className="right">[&nbsp;&nbsp;]</td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={6}></td>
                  </tr>

                  {key === (page?.length - 1) && (
                    <tr>
                      <td colSpan={3} style={{verticalAlign: 'top', borderTop: '1px solid #000'}}>
                        <table cellSpacing={0} cellPadding={5}>
                          <tr>
                            <td width="85.5%">CHECKSHEET :</td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{textAlign: 'left'}}>
                              <pre style={{
                                margin: 0,
                                padding: 0,
                                whiteSpace: 'pre-wrap'
                              }}>
                                [  ] KESESUAIAN QUANTITY & ITEM <br />[  ] FROZEN & FRESH FOOD <br />[  ] FINAL CHECK <br />[  ] KESESUAIAN JUMLAH KOLI
                              </pre>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td colSpan={3} style={{verticalAlign: 'top', borderTop: '1px solid #000'}}>
                        <table cellSpacing={0} cellPadding={5}>
                          <tr>
                            <td width="73.5%">PACKAGING :</td>
                          </tr>
                          <tr>
                            <td colSpan={2}>
                              <pre style={{
                                margin: 0,
                                padding: 0,
                                whiteSpace: 'pre-wrap'
                              }}>
                                [  ] PLASTIK<br />[  ] DUS<br />[  ] KARUNG<br />[  ] JUMLAH KOLI
                              </pre>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  )}
                </table>

                {key === (page?.length - 1) && (
                  <table className='body' cellPadding={5} cellSpacing={0}>
                    <thead className='bg-sections'>
                      <th width="25%" className="center border-top">PICKER</th>
                      <th width="25%" className="center border-top">CHECKER</th>
                      <th width="25%" className="center border-top">DRIVER</th>
                      <th width="25%" className="center border-top">CUSTOMER</th>
                    </thead>
                    <tr>
                      <td className="center" style={{height: 40}}>&nbsp;</td>
                      <td className="center"></td>
                      <td className="center"></td>
                      <td className="center"></td>
                    </tr>
                    <tr>
                      <td className="center border-top border-bottom" style={{height: 10}}>&nbsp;</td>
                      <td className="center border-top border-bottom"></td>
                      <td className="center border-top border-bottom"></td>
                      <td className="center border-top border-bottom"></td>
                    </tr>
                    <tr>
                      <td colSpan={4}>
                        <p>
                          Catatan: <br />Ditandatangi dan Stemple penerima apabila ada <br />
                          Hijau: Customer, Kuning: Warehouse, Putih & Merah: Finance
                        </p>
                      </td>
                    </tr>
                  </table>
                )}

                <div class="footer">
                  <p style={{
                    marginBottom: 40,
                    marginRight: 60
                  }}>
                  Page { key + 1 } of { page.length }
                  </p>
                </div>
              </section>
            ))}
          </>
        )}
      />
    </div>
  );
};

export default PrintFulfillment;
